import styled from "styled-components";
import DropdownIcon from "assets/svgs/dropdown_arrow.svg";

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.6rem;
`;

const InputField = styled.div`
  display: flex;
  width: 341px;
  margin-top: 24px;
  border: 1px solid #436ab2;
  border-radius: 6px;
  padding: 5px;
  justify-content: left;
  cursor: pointer;
  height: 50px;
  margin-right: 20px;
  /* & > input{
        display: none;
    }   */
`;

const DropdownInputErrorWrapper = styled.div`
  position: relative;
  width: 40rem;
  &::after {
    content: ""; /* pass the character as content */
    width: 20px;
    height: 20px;
    display: block;
    position: absolute;
    right: 14px;
    z-index: 10;
    top: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    transform: translateY(-50%);
    background-image: url(${DropdownIcon});
    pointer-events: none;
  }
`;

const InputErrorWrapper = styled.div`
  position: relative;
  width: 40rem;
`;

const Label = styled.label`
  font-family: "Inter";
  color: #4a4a4a;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 33px;
`;

const Input = styled.input`
  font-family: "Inter";
  background: #f9fcff;
  border: 1px solid #436ab2;
  border-radius: 5px;
  padding: 1.2rem 2rem;
  white-space: nowrap;
  width: 100%;
  font-size: 14px;
`;

const DropdownInputStyle = styled.input`
  font-family: "Inter";
  background: #f9fcff;
  border: 1px solid #436ab2;
  border-radius: 5px;
  padding: 1.2rem 2rem;
  white-space: nowrap;
  width: 100%;
  font-size: 14px;
  position: relative;
  -webkit-appearance: none;
`;

const Error = styled.p`
  color: red;
  font-size: 10px;
  bottom: -0.7rem;
  margin-left: 0.2rem;
  position: absolute;
  z-index: 9;
  font-family: 'Inter', sans-serif;
`;

const Divider = styled.div`
  height: 1px;
  background-color: #979797;
  margin: 2rem 0;
`;

const Divv = styled.div`
  height: 0;
  border-bottom: 0.1px solid #979797;
  /* change color and thickness as desired */
  text-align: center;
  position: relative;
  margin: 2rem 2rem;
`;

const DividerOr = styled.span`
  display: inline-block;
  /* color: white; */
  position: relative;
  top: -13px; /* adjust this value to vertically center the text */
  background-color: white;
  /* change background color as desired */
  padding: 0 10px;
  font-size: 18px;
`;

export {
  InputWrapper,
  Label,
  Input,
  InputErrorWrapper,
  Error,
  Divider,
  DropdownInputStyle,
  DropdownInputErrorWrapper,
  Divv,
  DividerOr,
  InputField,
};
